import { H3 } from 'components/texts'
import { columns } from './columns.js'
import { Box, Paper } from '@mui/material'
import Container from '@mui/material/Container'
import React, { useEffect, useState } from 'react'
import { Search as SearchIcon } from '@mui/icons-material'
import { ListTableHeader } from 'pages/logged/admin/components'
import { Accordion, BreadcrumbsList, Datagrid } from 'components/data_display'
import SearchFormFichaje, { search } from 'components/forms/display/empleado/fichaje/fichaje/SearchForm'

/**
 * Listado de las tutorias
 */
export default function ListadoTutorias() {
  const [data,         setData]         = useState({data: [], rowCount: 0})
  const [loadingTable, setLoadingTable] = useState(false)
  const [params,       setParams]       = useState(null)

  useEffect(() => {
    setLoadingTable(false)
  }, [data])

  /**
   * Callback para actualizar la tabla una vez hecha la petición
   * 
   * @param {Array} data 
   * @param {Int}   rowCount 
   */
  const updateTable = (data, rowCount, page, params) => {
    setData({data, rowCount})
    setParams(params)
  }
  

  return (
    <Container maxWidth={false} sx={{ mt: 5 }}>
      <BreadcrumbsList breadcrumbsList={[
        { label: "Inicio",    to: "/" },
        { label: "Empleados", to: "../../empleado/listado" },
        { label: "Fichaje" },
        { label: "Historial de fichajes", to: "./", actualItem: true },
      ]} />


      <Accordion header={<Box display={"flex"} alignItems={"center"}><SearchIcon className={"mx-5"} /> <H3 className="my-0">Buscar fichajes</H3></Box>}>
        <SearchFormFichaje
          searchCallback    = {updateTable}
          onLoadingCallback = {setLoadingTable} />
      </Accordion>

      <Paper elevation={2} sx={{mx: 8, my: 2, p: 5}}>
        <ListTableHeader rowCount={data.rowCount} params={params} keyValue={"fichajes"} hideAddButton/>

        <Datagrid
          rows         = {data.data}
          columns      = {columns}
          loading      = {loadingTable}
          rowCount     = {data.rowCount}
          onPageChange = {(page) => { search(page, () => setLoadingTable(true), updateTable) }}
          serverSide />
      </Paper>
    </Container>
  )
}
